/* unplugin-vue-components disabled */import { render } from "./ExDialog.vue?vue&type=template&id=4709622a"
import script from "./ExDialog.vue?vue&type=script&lang=js"
export * from "./ExDialog.vue?vue&type=script&lang=js"

import "./ExDialog.vue?vue&type=style&index=0&id=4709622a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__